<div class="main-dialog">

	<div class="dialog-header">
		<div class="header-title">
			<span style="font-size: 120%;"><span style="margin-right: 0.25em;">
					Estimates {{userName}}
					{{startDate | date: 'MMM d, y'}} - {{finishDate | date: 'MMM d, y'}}
				</span>
			</span>
		</div>

		<div style="flex: 1">

		</div>

		<button mat-button class="header-button" (click)="openEstimateEditor()">
			<mat-icon>add</mat-icon>
			Create Estimate
		</button>

		<button mat-button class="close-button-container" (click)="close()" disableRipple="true">
			<mat-icon>clear</mat-icon>
		</button>
	</div>


	<div class="middle-content">
		<div class="header-order">
			<div class="date-block label-block">
				<div class="label-name" (click)="sortByLabel('txnDate')" matRipple>DATE
					<i *ngIf="sortMap.get('txnDate') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('txnDate') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="project-block label-block">
				<div class="label-name" (click)="sortByLabel('projectNumber')" matRipple>PROJECT
					<i *ngIf="sortMap.get('projectNumber') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('projectNumber') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="total-block label-block">
				<div class="label-name" (click)="sortByLabel('amount')" matRipple>AMOUNT
					<i *ngIf="sortMap.get('amount') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('amount') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="original-amount-block label-block">
				<div class="label-name">INITIAL</div>
			</div>
			<div class="percent-block label-block">
				<div class="label-name">PERCENT</div>
			</div>
			<div class="status-block label-block">
				<div class="label-name" (click)="sortByLabel('txnStatus')" matRipple>STATUS
					<i *ngIf="sortMap.get('txnStatus') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('txnStatus') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="icons-block label-block">
				<div class="label-name">FLAGS</div>
			</div>
			<div class="actions-block">
			</div>
		</div>

		<div class="transaction-lines">

			<div class="transaction-line"
				*ngFor="let estimate of estimates; index as i; trackBy: trackEntityById">

				<div class="date-block label-block">
					<div class="label-name">{{estimate.txnDate | date: 'MM/dd/yyyy'}}</div>
				</div>
				<div class="project-block label-block">
					<div class="label-name clickable" (click)="openProject(estimate.projectId)">
						{{estimate.projectName}}
					</div>
				</div>
				<div class="total-block label-block">
					<div class="label-name clickable" (click)="openEstimateEditor(estimate)">
						{{estimate.amount | number:'1.2-2'}}
					</div>
				</div>
				<div class="original-amount-block label-block">
					<div class="label-name">
						<span>{{getOriginalAmount(estimate)}}</span>
					</div>
				</div>
				<div class="percent-block label-block">
					<div class="label-name">
						<span>{{(estimate.percentage == null ? 100 : estimate.percentage) | number:'1.2-2'}}%</span>
					</div>
				</div>
				<div class="status-block label-block">
					<div class="label-name">{{estimate.txnStatus}}</div>
				</div>
				<div class="icons-block label-block">
					<mat-icon *ngIf="estimate.userModified" class="flag-icon" title="User Modified">edit</mat-icon>
                    <mat-icon *ngIf="estimate.parentId" class="flag-icon" title="Split Estimate">call_split</mat-icon>
					<mat-icon *ngIf="estimate.createdManually && !estimate.parentId" class="flag-icon" title="Created Manually">add_circle</mat-icon>
				</div>
				<div class="actions-block">
					<button mat-icon-button class="action-button" *ngIf="estimate.qbTxnId" (click)="openInQb(estimate)" title="Open in QuickBooks">
						<mat-icon>open_in_new</mat-icon>
					</button>
					<button mat-icon-button class="action-button" (click)="openEstimateEditor(estimate)" title="Edit">
						<mat-icon>edit</mat-icon>
					</button>
					<button mat-icon-button class="action-button" *ngIf="estimate.createdManually" (click)="deleteEstimate(estimate)" title="Delete">
						<mat-icon>delete</mat-icon>
					</button>
				</div>
			</div>

		</div>

		<div class="totals-summary" *ngIf="estimates.length > 0">
			<div class="date-block label-block"></div>
			<div class="project-block label-block">
				<div class="label-name total-label">Total:</div>
			</div>
			<div class="total-block label-block">
				<div class="label-name total-value">{{totalInfo.totalAmt | number:'1.2-2'}}</div>
			</div>
			<div class="original-amount-block label-block"></div>
			<div class="percent-block label-block"></div>
			<div class="status-block label-block"></div>
			<div class="icons-block label-block"></div>
			<div class="actions-block"></div>
		</div>

		<div class="projects-without-estimates-section" *ngIf="projectsWithoutEstimates.length > 0">
			<div class="section-header">
				<div class="section-title">Projects Without Estimates</div>
			</div>

			<div class="transaction-lines">
				<div class="transaction-line" *ngFor="let project of projectsWithoutEstimates; trackBy: trackProjectById">
					<div class="date-block label-block">
						<div class="label-name">{{project.date | date: 'MM/dd/yyyy'}}</div>
					</div>
					<div class="project-block label-block">
						<div class="label-name clickable" (click)="openProject(project.id)">
							{{project.name}}
						</div>
					</div>
					<div class="total-block label-block">
						<div class="label-name"></div>
					</div>
					<div class="original-amount-block label-block">
						<div class="label-name"></div>
					</div>
					<div class="percent-block label-block">
						<div class="label-name"></div>
					</div>
					<div class="status-block label-block">
						<div class="label-name"></div>
					</div>
					<div class="icons-block label-block">
						<div class="label-name"></div>
					</div>
					<div class="actions-block">
						<button mat-icon-button class="action-button" (click)="openEstimateEditorForProject(project)" title="Create Estimate">
							<mat-icon>add_circle</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="spinner-box" *ngIf="contentLoading">
			<mat-spinner class="spinner"></mat-spinner>
		</div>

	</div>

</div>

<p-confirmDialog appendTo="body"></p-confirmDialog>



